import { WatcherFunction } from '..'
import { watchAutoSwitchRequest } from './autoSwitch'
import { watchChangePasswordRequest } from './changePassword'
import { watchFetchMeRequest } from './me'
import { watchUpateContactRequest } from './updateContact'
import { watchUpatePreferencesRequest } from './updatePreferences'

export const meSagas: ReadonlyArray<WatcherFunction> = [
  watchAutoSwitchRequest,
  watchChangePasswordRequest,
  watchFetchMeRequest,
  watchUpateContactRequest,
  watchUpatePreferencesRequest,
]
